/* eslint-disable react-hooks/exhaustive-deps */
//import { useSelector } from "react-redux";
import Breadcrumb from "../../components/Common/Breadcrumb";
import { /*Row,*/ Col } from "reactstrap";
import { Container, Card, CardBody } from "reactstrap";
import { useSelector } from "react-redux";
import NewAdminModalOld from "../Modals/NewAdminModalOld.js";
import { getUserByComp } from "../../services/api/userService.ts";
import { getGroupeByCompID } from "../../services/api/groupeServices.ts";
import React, { useEffect, useState } from "react";

const DetailsCompany = () => {
  // Accédez à la partie de l'état du store Redux contenant les données de l'entreprise
  const company = useSelector((state) => state.company.company);

  const [user, setUser] = useState([]);
  const [groupComp, setGroupComp] = useState([]);
  const [admin, setAdmin] = useState([]);
  const [student, setStudent] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      await fetchGroup();
    };

    fetchData();
  }, [company]);

  useEffect(() => {
    if (groupComp) {
      fetchUser();
    }
  }, [groupComp]);

  useEffect(() => {
    const adminTab = [];
    const studentTab = [];
    if (user) {
      user.forEach((item) => {
        if (item.user_ROLE_ID === 1) {
          adminTab.push(item);
        } else {
          studentTab.push(item);
        }
      });
      setAdmin(adminTab);
      setStudent(studentTab);
    }
  }, [user]);

  const fetchGroup = async () => {
    try {
      const data = await getGroupeByCompID(company.cie_ID);
      setGroupComp(data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchUser = async () => {
    try {
      const data = await getUserByComp(groupComp.group_ID);
      setUser(data);
    } catch (error) {
      console.log(error);
    }
  };

  // Utilisez les données de l'entreprise dans votre composant
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Upzet" breadcrumbItem="Société" />
          <Card>
            <CardBody>
              <div className="d-flex">
                <div className="flex-grow-1 align-self-center">
                  <div className="text-muted">
                    <h5>{company.cie_NAME}</h5>
                    <p className="mb-1">{company.cie_ID}</p>
                    <p className="mb-0">{company.cie_ADDRESS}</p>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
          <Col lg={12}>
            <div className="card">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <h4 className="card-title mb-4">Administrateur</h4>
                  <NewAdminModalOld />
                </div>
                <div className="table-responsive">
                  <table className="table table-centered table-nowrap mb-0">
                    <thead>
                      <tr>
                        <th scope="col" style={{ width: "50px" }}>
                          <div className="form-check">
                            <label
                              className="form-check-label"
                              htmlFor="customCheckall"
                            ></label>
                          </div>
                        </th>
                        <th scope="col">Surname & Name</th>
                        <th scope="col">Phone</th>
                        <th scope="col">Email</th>
                      </tr>
                    </thead>
                    <tbody>
                      {admin.map((item, key) => (
                        <tr key={key}>
                          <td>
                            <div className="form-check">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id={item.user_NAME}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={item.user_SURNAME}
                              ></label>
                            </div>
                          </td>
                          <td>
                            <p className="mb-1 font-size-12">
                              {item.user_SURNAME}
                            </p>
                            <h5 className="font-size-15 mb-0">
                              {item.user_NAME}
                            </h5>
                          </td>
                          <td>{item.user_PHONE}</td>
                          <td>{item.user_EMAIL}</td>
                          <td>
                            <button
                              type="button"
                              className="btn btn-outline-success btn-sm me-1"
                            >
                              Edit
                            </button>
                            <button
                              type="button"
                              className="btn btn-outline-danger btn-sm me-1"
                            >
                              Cancel
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={12}>
            <div className="card">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <h4 className="card-title mb-4">Apprentie</h4>
                </div>
                <div className="table-responsive">
                  <table className="table table-centered table-nowrap mb-0">
                    <thead>
                      <tr>
                        <th scope="col" style={{ width: "50px" }}>
                          <div className="form-check">
                            <label
                              className="form-check-label"
                              htmlFor="customCheckall"
                            ></label>
                          </div>
                        </th>
                        <th scope="col">Surname & Name</th>
                        <th scope="col">Phone</th>
                        <th scope="col">Email</th>
                      </tr>
                    </thead>
                    <tbody>
                      {student.map((item, key) => (
                        <tr key={key}>
                          <td>
                            <div className="form-check">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id={item.user_NAME}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={item.user_SURNAME}
                              ></label>
                            </div>
                          </td>
                          <td>
                            <p className="mb-1 font-size-12">
                              {item.user_SURNAME}
                            </p>
                            <h5 className="font-size-15 mb-0">
                              {item.user_NAME}
                            </h5>
                          </td>
                          <td>{item.user_PHONE}</td>
                          <td>{item.user_EMAIL}</td>
                          <td>
                            <button
                              type="button"
                              className="btn btn-outline-success btn-sm me-1"
                            >
                              Edit
                            </button>
                            <button
                              type="button"
                              className="btn btn-outline-danger btn-sm me-1"
                            >
                              Cancel
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </Col>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default DetailsCompany;

//Creators : Thomas Castanier @3DDGAMES -- Under license